export default "__VITE_ASSET__ChS0XXsd__"